export default "__VITE_PUBLIC_ASSET__a585c24e__"